export class SearchCorrespondence {
  contactId: number;
  contactName?: string;
  categoryName?: string;
  categoryId: number;
  displayModifiedOn: string;
}
